<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">
      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-send" size="small" @click="openSendMessagePopup">{{ $t('send_message') }}</vs-button>
      </template>
      <vs-divider></vs-divider>
    </vx-card>

    <vx-card id="messageManagementDataContainer" :title="$t('message_management')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-message-management-tab-nav @openSendMessagePopup="openSendMessagePopup"></shared-message-management-tab-nav>
      </template>

      <shared-message-management-list
        :messages="messages"
        @customClickDelete="destroy"
      ></shared-message-management-list>

      <template slot="footer">
        <paginate
          :total="messagePages"
          :itemPerPage="itemPerPage"
          :click-handler="loadMessageData"
          :value="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

  </div>
</template>

<script>

import MessageManagement from '@/models/MessageManagement'
import Paginate from '@/mixins/paginate'
import SharedMessageManagementList from '@/views/Shared/MessageManagement/List'
import announcementSocket from '@/libs/sockets/announcements'
import SharedMessageManagementTabNav from '@/views/Shared/MessageManagement/TabNav'

import Utils from '@/helpers/utils'

export default {
  name: 'User.MessageManagement.SentHistory',
  mixins: [Paginate],
  components: {
    SharedMessageManagementList,
    SharedMessageManagementTabNav,
    Utils
  },
  data () {
    return {
      messages: {},
      messagePages: 1,
      itemPerPage: null,
      messageSearchParams: {}
    }
  },
  mounted () {
    this.loadMessageData(this.initialPage, null)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_message_management_table', this.reloadMessageData)
  },
  methods: {
    reloadMessageData () {
      this.loadMessageData(this.initialPage, null)
    },
    async loadMessageData (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#messageManagementDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await MessageManagement.allSentHistory({ ...this.messageSearchParams, page, itemPerPage })
      this.messages = response.data.data.messageManagements
      this.messagePages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      announcementSocket.getSocket().emit('init_message_management_count')
      this.$vs.loading.close('#messageManagementDataContainer > .con-vs-loading')
    },
    openSendMessagePopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'send-message', {})
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await MessageManagement.destroy(id)
        this.loadMessageData(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style scoped>

</style>
